import type { ElementType } from 'react'

import cn from '@components/utils/cn'

export type SectionNavItem = { label: string; href: string; current?: boolean }

export type SectionNavProps = {
  items: SectionNavItem[]
  ariaLabel: string
  linkComponent?: ElementType<{ href: string; className?: string; 'aria-current'?: 'page' }>
}

export type SectionNavLinks = { label: string; items: SectionNavItem[] }

export function SectionNav({ items, ariaLabel, linkComponent: LinkComponent = 'a' }: SectionNavProps) {
  return (
    <nav aria-label={ariaLabel} className="tw:shrink-0 tw:md:sticky tw:md:top-4 tw:md:w-52">
      <ul className="tw:m-0 tw:flex tw:list-none tw:flex-wrap tw:gap-1 tw:p-0 tw:md:flex-col tw:md:gap-px">
        {items.map(({ label, href, current }) => (
          <li key={href}>
            <LinkComponent
              href={href}
              aria-current={current ? 'page' : undefined}
              className={cn(
                'tw:block tw:rounded-md tw:px-3 tw:py-2 tw:text-sm tw:font-medium tw:no-underline',
                'tw:focus-visible:outline-hidden tw:focus-visible:ring-2 tw:focus-visible:ring-primary-500',
                current
                  ? 'tw:bg-primary-50 tw:text-primary-700'
                  : 'tw:text-gray-cool-600 tw:hover:bg-gray-cool-100 tw:hover:text-gray-cool-900'
              )}
            >
              {label}
            </LinkComponent>
          </li>
        ))}
      </ul>
    </nav>
  )
}
